/*
 * Copyright (c) 2020. American Express Company
 */

import { RuleMatcher } from 'src/types/ruleMatcher.enum';

export class IncomeSourceRuleModel {
    incomeRuleUid!: string;
    incomeUid: string;
    transactionNamePattern: string;
    matcher: RuleMatcher;
    planUid!: string;
    priority!: number;
    userUid!: string;
}
